import React from 'react';
import './Legal.css';

const TermsOfService = () => {
  return (
    <div className="legal-container">
      <h1>Terms of Service</h1>
      <p className="last-updated">Last Updated: April 27, 2026</p>

      <section>
        <h2>1. Terms</h2>
        <p>By accessing the website at The Claw Gen, you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.</p>
      </section>

      <section>
        <h2>2. Use License</h2>
        <p>Permission is granted to temporarily download one copy of the materials (information or software) on The Claw Gen's website for personal, non-commercial transitory viewing only.</p>
      </section>

      <section>
        <h2>3. Disclaimer</h2>
        <p>The materials on The Claw Gen's website are provided on an 'as is' basis. The Claw Gen makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
      </section>

      <section>
        <h2>4. Limitations</h2>
        <p>In no event shall The Claw Gen or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on The Claw Gen's website.</p>
      </section>

      <section>
        <h2>5. Governing Law</h2>
        <p>These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which The Claw Gen operates and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
      </section>

      <section>
        <h2>6. WhatsApp Service Terms</h2>
        <p>By using the WhatsApp integration provided by The Claw Gen, you agree to the following:</p>
        <ul>
          <li>You will comply with the official <a href="https://www.whatsapp.com/legal/business-policy/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit' }}>WhatsApp Business Policy</a> at all times.</li>
          <li>You are solely responsible for ensuring that your end-customers have explicitly opted in to receive messages from your agent.</li>
          <li>The Claw Gen reserves the right to disable or terminate integrations that violate WhatsApp or Meta platform policies without prior notice.</li>
        </ul>
      </section>

      <div className="legal-back">
        <a href="/">← Back to Home</a>
      </div>
    </div>
  );
};

export default TermsOfService;
